/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function UserIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="none" stroke="currentColor" viewBox="0 0 20 20" aria-hidden="true" {...props}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M13.125 5C13.125 5.8288 12.7958 6.62366 12.2097 7.20971C11.6237 7.79576 10.8288 8.125 10 8.125C9.1712 8.125 8.37634 7.79576 7.79029 7.20971C7.20424 6.62366 6.875 5.8288 6.875 5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5ZM3.75083 16.765C3.77761 15.1253 4.44778 13.5618 5.61681 12.4117C6.78585 11.2616 8.36007 10.6171 10 10.6171C11.6399 10.6171 13.2142 11.2616 14.3832 12.4117C15.5522 13.5618 16.2224 15.1253 16.2492 16.765C14.2887 17.664 12.1568 18.1279 10 18.125C7.77 18.125 5.65333 17.6383 3.75083 16.765Z"
            />
        </svg>
    );
}
